import PropTypes from 'prop-types';

export const isPassValid = (oldPassword, newPassword, confirmPassword, setMessage) => {
  if (oldPassword.trim().length === 0) {
    setMessage('Escribe tu contraseña actual')
    return false;
  } else if (newPassword.trim().length === 0) {
    setMessage('Escribe la nueva contraseña')
    return false;
  } else if (newPassword.trim().length <= 7) {
    setMessage('La nueva contraseña debe tener al menos 8 carácteres')
    return false;
  } else if (newPassword !== confirmPassword) {
    setMessage('Las contraseñas no coinciden')
    return false;
  } else if (!(/[a-z]/.test(newPassword))) {
    setMessage('La nueva contraseña debe contener al menos una minúscula')
    return false;
  } else if (!(/[A-Z]/.test(newPassword))) {
    setMessage('La nueva contraseña debe contener al menos una mayúscula')
    return false;
  } else if (!(/[0-9]/.test(newPassword))) {
    setMessage('La nueva contraseña debe contener al menos un número')
    return false;
  } else if (/^$|\s+/.test(newPassword)) {
    setMessage('La nueva contraseña no debe llevar espacio en blanco')
    return false;
  }
  return true;
}

isPassValid.propTypes = {
  oldPassword: PropTypes.string.isRequired,
  newPassword: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
  setMessage: PropTypes.func.isRequired
}